/* eslint-disable array-callback-return */
import { OrderID } from 'framework/orders'
import { EcommerceService } from 'services'
import { CustomerService } from 'modules/customers/services'
import type {
  CreateOrderFail,
  CreateOrderSuccess,
  Order,
  OrderItems,
  OrderShippingTotal,
} from 'modules/orders/services'

export default class CartService extends EcommerceService {
  private order: Order = {} as unknown as Order

  private items: OrderItems = []

  private shipping: OrderShippingTotal = 0

  private customerService: CustomerService

  constructor(customerService: CustomerService) {
    super()
    this.customerService = customerService
  }

  setOrderId(id: OrderID) {
    this.order = {
      ...this.order,
      id,
    }
  }

  setOrder(order: Order) {
    this.order = order
    return this
  }

  getOrder(): Order {
    return this.order
  }

  setItems(items: any[]): CartService {
    this.items = items
    return this
  }

  getItems() {
    return this.items
  }

  setShipping(shipping: number): CartService {
    this.shipping = shipping
    return this
  }

  getShipping() {
    return this.shipping
  }

  async create(onSucess: CreateOrderSuccess, onFail: CreateOrderFail): Promise<void> {
    try {
      const { id } = this.customerService.getCustomer()
      const payload = {
        customer_id: id,
        items: this.getItems().map((item) => ({
          product_id: item.id,
          quantity: item.quantity,
          discount: 0,
        })),
        total_shipping: this.order.shippingTotal,
      }

      const { data } = await this.setUrl('/orders').post(payload)
      const orderId = data.order_id as string as OrderID
      this.setOrder({ id: orderId } as Order)
      onSucess(orderId)
    } catch (e) {
      onFail()
    }
  }

  async getOrderById(orderId: OrderID, onSucess: CreateOrderSuccess, onFail: CreateOrderFail): Promise<void> {
    try {
      const url = `/orders/${orderId}`
      const {
        data: { order, items },
      } = await this.setUrl(url).get()
      const data = { ...order, id: order.id, items }
      this.setOrder(data)
      onSucess(data)
    } catch (e) {
      onFail()
    }
  }

  async getOrderItemsById(orderId: OrderID, onSucess: (items: any[]) => void, onFail: CreateOrderFail): Promise<void> {
    try {
      const url = `/orders/${orderId}`
      const {
        data: { order },
      } = await this.setUrl(url).get()
      const data: any[] = order.sub_orders
      const items: any[] = []

      // @ts-ignore
      data.map((sb) => {
        // @ts-ignore
        ;(sb.order_items as any[]).map((oi) => {
          const { quantidade, product } = oi
          // const { status } = product
          // if (quantidade >= product.quantidade_estoque && status !== 'INATIVO') {
          if (quantidade <= product.quantidade_estoque) {
            items.push({
              id: product.id,
              name: product.nome,
              slug: product.slug,
              price: product.preco,
              quantity: quantidade,
              seller: sb.farmer,
            })
          }
        })
      })

      onSucess(items)
    } catch (e) {
      onFail()
    }
  }
}
